import { Injectable } from '@angular/core';
// TODO : Deprecate this service, use shared ui focus service
@Injectable({
  providedIn: 'root'
})
export class FocusHelperService {
  public scrollToTopOffset(elementId, timeout = 300, headerHeight = 60): void {
    if (elementId) {
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (!element) return;
        const minimumTopOffset = headerHeight + 16;
        const elementPosition = element.getBoundingClientRect().top;
        const topOffset = element.offsetTop < minimumTopOffset ? elementPosition - headerHeight : element.offsetTop - 160;
        window.scrollTo({ behavior: 'smooth', top: topOffset });
      }, timeout);
    }
  }

  public focusElement(elementId, timeout = 300): void {
    if (elementId) {
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.focus();
        }
      }, timeout);
    }
  }
}
